// extracted by mini-css-extract-plugin
export var actionText = "_r4-4";
export var container = "_r4-0";
export var leftSection = "_r4-1";
export var rightSection = "_r4-2";
export var settingsButton = "_r4-6";
export var settingsIcon = "_r4-7";
export var shortcut = "_r4-5";
export var shortcutGroup = "_r4-3";